import script from "./TradeCompanySelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradeCompanySelect.vue?vue&type=script&setup=true&lang=ts"

import "./TradeCompanySelect.vue?vue&type=style&index=0&id=e956577e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e956577e"]])

export default __exports__